import {registerComponent} from '@helpers/vue'
import PoultryManagement from 'src/vue/areas/poultry-management/PoultryManagement'

registerComponent(PoultryManagement, 'poultry-management')
